import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";

type Props = {
  data: { end_date?: string };
  HandleDataProps: (payload: { end_date: string | null }) => void;
  externalErrorId?: string;
};

const RequirementEndDateChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [endDate, setEndDate] = useState<string | null>(null);
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    if (data?.end_date) {
      setEndDate(data.end_date);
    }
  }, [data?.end_date]);

  useEffect(() => {
    HandleDataProps({ end_date: endDate });
  }, [endDate, HandleDataProps]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!endDate) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.ENDDATE.AFTERSTART');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ end_date: endDate }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">End Date</p>
      <div className="relative max-w-xs mt-2">
        <ReactDatePicker
          InputDivClass="mt-2"
          selected={endDate}
          onChange={(val: string) => setEndDate(val)}
          minDate={new Date()}
          placeholderText="Select end date"
          error={externalErrorId || errorId}
        />
      </div>
    </div>
  );
});

export default RequirementEndDateChange;
